<template>
  <a-layout-sider class="dolphin-side-bar" :width="menuCollapseFlag?'60px':'200px'">
    <div class="dol-menu-panel">
      <div class="menu-title">
        <img src="../../../public/static/icon/favicon.png" />
        <!--        <template v-if="menuCollapseFlag">-->
        <!--          <img src="../../../public/static/icon/favicon.png" />-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <img src="../../../public/static/icon/logo.png" />-->
        <!--        </template>-->
      </div>
      <div class="dol-menu-collapse" @click="toggleCollapse">
        <a-icon :type="menuCollapseFlag ? 'menu-unfold' : 'menu-fold'" />
      </div>
      <div class="dol-menu" v-if="$store.state.userInfo">
        <a-menu class="sideMenu"
                theme="dark"
                :mode="menuCollapseFlag?'vertical':'inline'"
                :selectedKeys="selectMenu"
                :openKeys.sync="openMenu">
          <template v-for="item in menuList">
            <a-menu-item v-if="item.isLeaf" :key="item.ASSEMBLY" @click="$goPath(item)">
              <a-icon v-if="item.MENU_IMAGE" :type="item.MENU_IMAGE" />
              <span v-if="!menuCollapseFlag">{{ item.MENU_NAME }}</span>
            </a-menu-item>
            <sub-menu v-else :key="item.ASSEMBLY" :menu-info="item" :menu-collapse-flag="menuCollapseFlag" />
          </template>
        </a-menu>
      </div>
    </div>
  </a-layout-sider>
</template>

<script>
import { mapState } from 'vuex';
import SubMenu from '@/components/common/side-bar-sub-menu';

export default {
  name: 'dol-menu',
  components: {SubMenu},
  data() {
    return {
      openMenu: [],
      curSubMenuCode: '',
      menuCollapse: false,
    };
  },
  computed: {
    ...mapState(['menuTree']),
    menuCollapseFlag() {
      if (this.menuList?.length > 0) {
        return this.menuCollapse;
      } else {
        return true;
      }
    },
    menuList(){
      let firstMenu = this.menuTree.find(item => new RegExp('^' + item.ASSEMBLY + '/').test(this.$route.path));
      return firstMenu?.children;
    },
    selectMenu: {
      get() {
        return [this.$route.path];
      },
      set() {

      },
    },
  },
  watch: {
    $route() {
      let pathArray = this.$route.path.split('/');
      let fullPath = '';
      pathArray.forEach((path, index) => {
        if(index > 0 && index < pathArray.length - 1){
          fullPath += '/' + path;
          if(!this.openMenu.find(item => item === fullPath)){
            this.openMenu.push(fullPath);
          }
        }
      });
    }
  },
  methods: {
    linkPage({ key }) {
      if (this.$route.path !== key) this.$router.push(key);
    },
    toggleCollapse() {
      this.openMenu = [];
      this.menuCollapse = !this.menuCollapse;
    }
  },
  created() {
  },
};
</script>
